<div class="inputFiled__container">
    <label class="{{labelClass || 'inputField__label'}}" >{{label}}<span *ngIf="starIcon"
            class="spmred">{{starIcon}}</span></label>
    <input alphabets (keydown)="onKeyDown($event, label)" (paste)="onPaste($event)" (input)="getInputValue($event)"  class="inputFiled__tataSteel"  id="tataSteel" placeholder={{placeholder}} value={{value}} type="{{type}}"
        max="{{maxDate}}" [min]="min" [readonly]="readonly ? 'readonly' : null" (ngModelChange)="onChange($event)"
           [formControl]="control" [maxlength]="maxlength" [minlength]="minlength" [ngModel]="value" [autocomplete]="autocomplete" [ngClass]="{'borderColor': borderColor}">
</div>
